module.exports = __webpack_public_path__ + "static/media/VA_Home_Loans.b18aac13.png";